import { createVNode as _createVNode } from "vue";
/**
 * @author zhouchangluan
 * @fileoverview PC首页 - 容器
 */
import { defineComponent, provide } from "vue";
// components
// 赛事说明 - 赛程安排
import RaceProcessPlan from "@/components/pc/race-process-plan.vue";
// 赛事进程
import MatchProcess from "./components/matchProcess.vue";
// 热点资讯
import Information from "./components/information.vue";
// 精选视频
import Video from "./components/video.vue";
// hooks
import { useHomePage } from "@/hooks/home-page";
// context
import { homePageContextKey } from "@/context/home-page";
export default defineComponent({
  name: "PcHomePage",
  props: {
    // 是否是被其它组件引入
    referType: {
      type: String,
      default: ""
    }
  },
  setup() {
    //hooks
    const {
      homePageState,
      raceQuarterSwitchFct,
      groupSwitchFct,
      raceTypeSwitchFct,
      // 积分赛模块
      integrationState,
      integRef
    } = useHomePage();
    provide(homePageContextKey, {
      homePageState,
      raceQuarterSwitchFct,
      groupSwitchFct,
      raceTypeSwitchFct,
      // 积分赛模块
      integrationState,
      integRef
    });

    // 组件状态
    return () => {
      return _createVNode("div", {
        "class": "home-inner pc-explain"
      }, [_createVNode(RaceProcessPlan, null, null), _createVNode(MatchProcess, {
        "id": "match-box"
      }, null), _createVNode(Information, {
        "id": "info-box"
      }, null), _createVNode(Video, {
        "id": "video-box"
      }, null)]);
    };
  }
});